<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-5">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                <td>
                  <flat-pickr @on-change="onChangeDate" :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-7">
            <!-- <div class="row">
              <div class="col-sm-6 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-6">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15">
        <b-table class="table-custom" @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(date)="data">
<!--          <template slot="date" slot-scope="data">-->
            {{parseDate(data.item.date)}}
          </template>
          <template v-slot:cell(member_id)="data">
<!--          <template slot="member_id" slot-scope="data">-->
            <div v-if="data.item.transaction_detail.member_pt_session && data.item.transaction_detail.member_pt_session.member">
              <template v-if="data.item.transaction_detail.member_pt_session.member.branch">
                {{data.item.transaction_detail.member_pt_session.member.branch.codename}}{{data.item.transaction_detail.member_pt_session.member.id}}
              </template>
              <template v-else>
                FT{{data.item.transaction_detail.member_pt_session.member.id}}
              </template>
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(member_name)="data">
<!--          <template slot="member_name" slot-scope="data">-->
            <div v-if="data.item.transaction_detail.member_pt_session && data.item.transaction_detail.member_pt_session.member">
              {{data.item.transaction_detail.member_pt_session.member.first_name}} {{data.item.transaction_detail.member_pt_session.member.last_name}}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(employee_id)="data">
<!--          <template slot="employee_id" slot-scope="data">-->
            <div v-if="data.item.transaction_detail.member_pt_session">
              {{data.item.transaction_detail.member_pt_session.personal_trainer_id}}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(employee_name)="data">
<!--          <template slot="employee_name" slot-scope="data">-->
            <div v-if="data.item.transaction_detail.member_pt_session && data.item.transaction_detail.member_pt_session.personal_training">
              {{data.item.personal_training.name}}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(training_product)="data">
<!--          <template slot="training_product" slot-scope="data">-->
            <div v-if="data.item.transaction_detail.member_pt_session && data.item.transaction_detail.member_pt_session.pt_session">
              PT {{data.item.transaction_detail.member_pt_session.pt_session.training_product}}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(is_manual_running)="data">
            <template>
              <b-badge v-if="data.item.is_manual_running == 1" :variant="'success'" >Yes</b-badge>
              <b-badge v-if="data.item.is_manual_running == 0"  :variant="'warning'" >No</b-badge>
            </template>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'gallery',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'id',
          label: 'TRX',
          sortable: true
        },
        {
          key: 'sales',
          label: 'Sales Name',
          sortable: true
        },
        {
          key: 'member',
          label: 'Member Name',
          sortable: false
        },
        {
          key: 'membership',
          label: 'Membership',
          sortable: false
        },
        {
          key: 'gross_amount',
          label: 'Gross Amount',
          sortable: false
        },
        {
          key: 'dues',
          label: 'Total Dues',
          sortable: false
        },
        {
          key: 'comission',
          label: 'Commission',
          sortable: false
        },
        {
          key: 'status_comission',
          label: 'Status Commission',
          sortable: false
        },
        {
          key: 'final_comission',
          label: 'Final Commission',
          sortable: false
        },
        {
          key: 'sales_type',
          label: 'Sales Type',
          sortable: false
        },
      ],
      items: [],
      dataBranch: [],
      branch_id: null,
      getRoleId: Auth.Session.get().paradigm_role,
      getID: Auth.Session.get().paradigm_id,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))],
        // onChange: this.onChange
      }
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    onChangeDate(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    parseCurrency(value) {
      // var newValue = value.toFixed()
      return value.toLocaleString('id-ID', {maximumFractionDigits:0})
    },
    openPage (event) {
      this.$router.push(event)
    },
    editGallery (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    parseDate(value) {
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'compro/v1/img/gallery/' + value
    },
    exportReport() {
      let dates = this.exportDates.split(' to ')
      let export_url = 'crm/v1/export/pt_report/komisi_sales?start_date='+dates[0]+'&end_date='+dates[1]

      axios({
        method: 'get',
        url: export_url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Komisi Sales (PT Report) '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    exportReportForAdmin() {
      let dates = this.exportDates.split(' to ')
      let export_url = 'crm/v1/export/pt_report/usage_log/admin_only?start_date='+dates[0]+'&end_date='+dates[1]

      axios({
        method: 'get',
        url: export_url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Usage Log (PT Report) '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeBranch(event) {
      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/pt_report/komisi_sales?page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start_date=' + dates1[0]
        + '&end_date=' + dates1[1]

        if (this.branch_id != null) {
          url += '&branch_id=' + event
        }

        axios.get(url).then(response => {
          this.items = response.data.data
          this.totalPage = 1
        }).catch(error => {
          console.log('error', error)
        })
    },
    fetchData() {
      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/pt_report/komisi_sales?page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start_date=' + dates1[0]
        + '&end_date=' + dates1[1]

        if (this.branch_id != null) {
          url += '&branch_id=' + this.branch_id
        }

        axios.get(url).then(response => {
          this.items = response.data.data
          // this.totalPage = response.data.data.length
          this.totalPage = 1
        }).catch(error => {
          console.log('error', error)
        })

        axios.get('fitness/v1/branch/').then(response => {
          this.dataBranch = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
